import type { Bcp47Locale } from '@backmarket/http-api'

export default function createLocaleFormatter(locale: Bcp47Locale) {
  return (localeToTranslate: Bcp47Locale) => {
    if (typeof Intl.DisplayNames !== 'function') {
      return localeToTranslate
    }

    const languageNames = new Intl.DisplayNames([locale], {
      type: 'language',
      languageDisplay: 'standard',
    })

    return languageNames.of(localeToTranslate) || localeToTranslate
  }
}
